// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._35kCd{position:absolute;width:100%;height:100%;top:0;left:0;background-repeat:no-repeat;background-position:50%;background-size:100%}._3DC-U,._35kCd{cursor:pointer;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}._3DC-U{width:100px;width:6.25rem;height:100px;height:6.25rem;background-color:rgba(35,24,21,.48);border-radius:100%}._3SxeY{width:32.5px;width:2.03125rem;height:37px;height:2.3125rem}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "_35kCd",
	"playerArrow": "_3DC-U",
	"playIcon": "_3SxeY"
};
module.exports = exports;
